import Authorship from '@/modules/content/editor/form/FormContentAuthorship';
import ArticleContent from '@/modules/content/editor/form/FormContentArticle';
import PhotogalleryContent from '@/modules/content/editor/form/FormContentPhotogallery';
import ImageContent from '@/modules/content/editor/form/FormContentImage';
import ImagePreview from '@/modules/content/editor/form/FormContentImagePreview';
import ContentAMP from '@/modules/content/editor/form/FormContentAMP';
import ContentMobile from '@/modules/content/editor/form/FormContentMobile';
import Multimedia from '@/modules/content/editor/form/FormContentMultimedia';
import MultimediaPhotogallery
  from '@/modules/content/editor/form/FormContentMultimediaPhotogallery';
import MultimediaChannel from '@/modules/content/editor/form/FormContentMultimediaChannel';
import Place from '@/modules/content/editor/form/FormContentPlace';
import Relation from '@/modules/content/editor/form/FormContentRelation';
import Schedules from '@/modules/content/editor/form/FormContentSchedules';
import Taxonomy from '@/modules/content/editor/form/FormContentCataloging';
import Customizations from '@/modules/content/editor/form/FormContentCustomizations';
import SEO from '@/modules/content/editor/form/FormContentSEO';
import SocialNetworkSending from '@/modules/content/editor/form/FormContentSocialNetworkSendings';
import LiveMessages from '@/modules/live-messages/components/MessageEditor';

import validationRules from './validation-rules';

export const scopes = {
  content: {
    scope: 'content',
    title: 'content',
    icon: 'sort',
    component: ArticleContent,
  },
  photogallery: {
    scope: 'content',
    title: 'content',
    icon: 'sort',
    component: PhotogalleryContent,
  },
  contentAMP: {
    scope: 'contentAMP',
    title: 'content',
    icon: 'sort',
    component: ContentAMP,
  },
  contentMobile: {
    scope: 'contentMobile',
    title: 'content',
    icon: 'sort',
    component: ContentMobile,
  },
  multimedia: {
    scope: 'multimedia',
    title: 'multimedia',
    icon: 'add_a_photo',
    component: Multimedia,
  },
  multimediaChannel: {
    scope: 'multimediaChannel',
    title: 'multimedia',
    icon: 'add_a_photo',
    component: MultimediaChannel,
  },
  authorship: {
    scope: 'authorship',
    title: 'authorship',
    icon: 'people',
    component: Authorship,
  },
  place: {
    scope: 'place',
    title: 'place',
    icon: 'pin_drop',
    component: Place,
  },
  schedules: {
    scope: 'schedules',
    title: 'schedules',
    icon: 'alarm',
    component: Schedules,
  },
  relations: {
    scope: 'relations',
    title: 'relations',
    icon: 'link',
    component: Relation,
  },
  cataloging: {
    scope: 'cataloging',
    title: 'cataloging',
    icon: 'folder',
    component: Taxonomy,
  },
  imageContent: {
    scope: 'imageContent',
    title: 'content',
    icon: 'sort',
    component: ImageContent,
  },
  imagePreview: {
    scope: 'imagePreview',
    title: 'preview',
    icon: 'photo',
    component: ImagePreview,
  },
  galleryMultimedia: {
    scope: 'galleryMultimedia',
    title: 'multimedia',
    icon: 'add_a_photo',
    component: MultimediaPhotogallery,
  },
  customizations: {
    scope: 'customizations',
    title: 'customizations',
    icon: 'call_split',
    component: Customizations,
  },
  seo: {
    scope: 'seo',
    title: 'seo',
    icon: 'book',
    component: SEO,
  },
  socialNetworksSendings: {
    scope: 'socialNetworksSendings',
    title: 'socialNetworksSendings',
    icon: 'share',
    component: SocialNetworkSending,
  },
  liveMessages: {
    scope: 'liveMessages',
    title: 'liveMessages',
    icon: 'forum',
    component: LiveMessages,
  },
};

export const forms = {
  article: {
    master: [
      scopes.content,
      scopes.cataloging,
      scopes.authorship,
      scopes.place,
      scopes.multimedia,
      scopes.relations,
      scopes.customizations,
      scopes.socialNetworksSendings,
      scopes.seo,
      scopes.schedules,
    ],
    mobile: [
      scopes.contentMobile,
      scopes.multimediaChannel,
    ],
    amp: [
      scopes.contentAMP,
    ],
  },
  image: {
    master: [
      scopes.imagePreview,
      scopes.imageContent,
      scopes.cataloging,
      scopes.authorship,
    ],
    mobile: [
      scopes.contentAMP,
    ],
    amp: [
      scopes.contentAMP,
    ],
  },
  photogallery: {
    master: [
      scopes.content,
      scopes.photogallery,
      scopes.cataloging,
      scopes.authorship,
      scopes.place,
      scopes.galleryMultimedia,
      scopes.relations,
      scopes.customizations,
      scopes.socialNetworksSendings,
      scopes.seo,
      scopes.schedules,
    ],
    mobile: [
      scopes.contentMobile,
    ],
    amp: [
      scopes.contentAMP,
    ],
  },
  live: {
    master: [
      scopes.content,
      scopes.liveMessages,
      scopes.cataloging,
      scopes.authorship,
      scopes.place,
      scopes.multimedia,
      scopes.relations,
      scopes.customizations,
      scopes.socialNetworksSendings,
      scopes.seo,
      scopes.schedules,
    ],
    mobile: [
      scopes.contentMobile,
      scopes.multimediaChannel,
    ],
    amp: [
      scopes.contentAMP,
    ],
  },
};

export default {
  validationRules,
  scopes,
  forms,
};
